/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne API
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: 9c5a7c5f (Mon Apr 13 19:32:58 UTC 2026)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {
  FetchMetricResponseBody,
  FetchMetricResponseBodyFromJSON,
  FetchMetricsResponseBody,
  FetchMetricsResponseBodyFromJSON,
} from '../models'
import * as runtime from '../runtime'

export interface FetchMetricRequest extends runtime.BaseRequestParameters {
  metricId: FetchMetricMetricIdEnum
  actorKey?: number
  academicYear?: number
}

export interface FetchMetricsRequest extends runtime.BaseRequestParameters {
  academicYear?: number
}

/**
 * DashboardApi - interface
 *
 * @export
 * @interface DashboardApiInterface
 */
export interface DashboardApiInterface {
  /**
   *
   * @summary Return the calculated result of the passed in metric.
   * @param {'LicensingDue' | 'InProgressInvitations' | 'PendingEnrollments' | 'UnassignedDirectors' | 'OutstandingTuition' | 'Programs' | 'ExpiredActors' | 'UnassignedTutors'} metricId The specific metricId to run. Comes from the metricId column in the database.
   * @param {number} [actorKey] If passed, this is used to calculate the metric instead of the calling actor key.
   * @param {number} [academicYear] If provided, this value is used to filter the metric by the specified year
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DashboardApiInterface
   */
  fetchMetricRaw(
    requestParameters: FetchMetricRequest
  ): Promise<runtime.ApiResponse<FetchMetricResponseBody>>

  /**
   * Return the calculated result of the passed in metric.
   */
  fetchMetric(
    requestParameters: FetchMetricRequest
  ): Promise<FetchMetricResponseBody>

  /**
   *
   * @summary Return all metrics granted to the current actingAs. The response will include a summary of the aggregate for each metric.
   * @param {number} [academicYear] If provided, this value is used to filter the metrics by the specified year
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof DashboardApiInterface
   */
  fetchMetricsRaw(
    requestParameters: FetchMetricsRequest
  ): Promise<runtime.ApiResponse<FetchMetricsResponseBody>>

  /**
   * Return all metrics granted to the current actingAs. The response will include a summary of the aggregate for each metric.
   */
  fetchMetrics(
    requestParameters: FetchMetricsRequest
  ): Promise<FetchMetricsResponseBody>
}

/**
 *
 */
export class DashboardApi
  extends runtime.BaseAPI
  implements DashboardApiInterface
{
  /**
   * Return the calculated result of the passed in metric.
   */
  async fetchMetricRaw(
    requestParameters: FetchMetricRequest
  ): Promise<runtime.ApiResponse<FetchMetricResponseBody>> {
    if (
      requestParameters.metricId === null ||
      requestParameters.metricId === undefined
    ) {
      throw new runtime.RequiredError(
        'metricId',
        'Required parameter requestParameters.metricId was null or undefined when calling fetchMetric.'
      )
    }

    const queryParameters: any = {}

    if (requestParameters.actorKey !== undefined) {
      queryParameters['actorKey'] = requestParameters.actorKey
    }

    if (requestParameters.academicYear !== undefined) {
      queryParameters['academicYear'] = requestParameters.academicYear
    }

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Cookie'] = this.configuration.apiKey('Cookie') // sessionIdCookie authentication
    }

    const response = await this.request({
      path: `/metric/{metricId}`.replace(
        `{${'metricId'}}`,
        encodeURIComponent(String(requestParameters.metricId))
      ),
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
      $signal: requestParameters.$signal,
    })

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      FetchMetricResponseBodyFromJSON(jsonValue)
    )
  }

  /**
   * Return the calculated result of the passed in metric.
   */
  async fetchMetric(
    requestParameters: FetchMetricRequest
  ): Promise<FetchMetricResponseBody> {
    const response = await this.fetchMetricRaw(requestParameters)
    return await response.value()
  }

  /**
   * Return all metrics granted to the current actingAs. The response will include a summary of the aggregate for each metric.
   */
  async fetchMetricsRaw(
    requestParameters: FetchMetricsRequest
  ): Promise<runtime.ApiResponse<FetchMetricsResponseBody>> {
    const queryParameters: any = {}

    if (requestParameters.academicYear !== undefined) {
      queryParameters['academicYear'] = requestParameters.academicYear
    }

    const headerParameters: runtime.HTTPHeaders = {}

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Cookie'] = this.configuration.apiKey('Cookie') // sessionIdCookie authentication
    }

    const response = await this.request({
      path: `/metrics`,
      method: 'GET',
      headers: headerParameters,
      query: queryParameters,
      $signal: requestParameters.$signal,
    })

    return new runtime.JSONApiResponse(response, (jsonValue) =>
      FetchMetricsResponseBodyFromJSON(jsonValue)
    )
  }

  /**
   * Return all metrics granted to the current actingAs. The response will include a summary of the aggregate for each metric.
   */
  async fetchMetrics(
    requestParameters?: FetchMetricsRequest
  ): Promise<FetchMetricsResponseBody> {
    const response = await this.fetchMetricsRaw(requestParameters || {})
    return await response.value()
  }
}

/**
 * @export
 * @enum {string}
 */
export enum FetchMetricMetricIdEnum {
  LicensingDue = 'LicensingDue',
  InProgressInvitations = 'InProgressInvitations',
  PendingEnrollments = 'PendingEnrollments',
  UnassignedDirectors = 'UnassignedDirectors',
  OutstandingTuition = 'OutstandingTuition',
  Programs = 'Programs',
  ExpiredActors = 'ExpiredActors',
  UnassignedTutors = 'UnassignedTutors',
}
